import React from 'react';

const Svg = ({ className, children }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">{children}</svg>
);

export const PlayerIcon = ({ className }) => (
  <Svg className={className}>
    <circle cx="12" cy="5.2" r="2.2" fill="currentColor" />
    <path d="M7 20l1.1-6.4c.2-1.1.9-2 1.9-2.4L12 10l2 1.2c1 .4 1.7 1.3 1.9 2.4L17 20" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.3 10.6L7 13m7.7-2.4L17 13" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </Svg>
);

export const KeeperIcon = ({ className }) => (
  <Svg className={className}>
    <circle cx="12" cy="5.2" r="2.2" fill="currentColor" />
    <path d="M7 20l1.1-6.4c.2-1.1.9-2 1.9-2.4L12 10l2 1.2c1 .4 1.7 1.3 1.9 2.4L17 20" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.3 10.6L6.4 12.8m8.3-2.2L17.6 12.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <rect x="5" y="11.9" width="2.4" height="2" rx="0.6" fill="currentColor" />
    <rect x="16.6" y="11.9" width="2.4" height="2" rx="0.6" fill="currentColor" />
  </Svg>
);

export const NeutralIcon = ({ className }) => (
  <Svg className={className}>
    <circle cx="12" cy="5.2" r="2.2" stroke="currentColor" strokeWidth="1.6" strokeDasharray="1.4 1.4" />
    <path d="M7 20l1.1-6.4c.2-1.1.9-2 1.9-2.4L12 10l2 1.2c1 .4 1.7 1.3 1.9 2.4L17 20" stroke="currentColor" strokeWidth="1.6" strokeDasharray="2 1.6" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export const CoachIcon = ({ className }) => (
  <Svg className={className}>
    <circle cx="9.4" cy="5.2" r="2" fill="currentColor" />
    <path d="M6 20l0.8-5.6c.2-1.2 1-2.1 2.1-2.4l1.4-.4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="13" y="10.4" width="6.4" height="8.4" rx="1" stroke="currentColor" strokeWidth="1.5" />
    <path d="M14.6 13.1h3.2M14.6 15.6h3.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </Svg>
);

export const BallIcon = ({ className }) => (
  <Svg className={className}>
    <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.6" />
    <path d="M12 8.4l3 2.2-1.1 3.5H10.1L9 10.6z" fill="currentColor" />
    <path d="M12 8.4V5.6M15 10.6l2.6-1.4M10.9 14.1l-1.7 2.6M13.1 14.1l1.7 2.6M9 10.6L6.4 9.2" stroke="currentColor" strokeWidth="1.1" />
  </Svg>
);

export const ConeIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M12 4l3.4 12.4H8.6L12 4z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M7.4 19.6h9.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M9.6 11.6h4.8" stroke="currentColor" strokeWidth="1.3" />
  </Svg>
);

export const HurdleIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M5.5 19.5V9M18.5 19.5V9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <rect x="4.5" y="8.6" width="15" height="2.6" rx="0.8" fill="currentColor" />
  </Svg>
);

export const PoleIcon = ({ className }) => (
  <Svg className={className}>
    <line x1="12" y1="3.5" x2="12" y2="18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <ellipse cx="12" cy="19.6" rx="4" ry="1.4" stroke="currentColor" strokeWidth="1.4" />
  </Svg>
);

export const LadderIcon = ({ className }) => (
  <Svg className={className}>
    <line x1="7" y1="3.5" x2="7" y2="20.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <line x1="17" y1="3.5" x2="17" y2="20.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <line x1="7" y1="7" x2="17" y2="7" stroke="currentColor" strokeWidth="1.4" />
    <line x1="7" y1="11" x2="17" y2="11" stroke="currentColor" strokeWidth="1.4" />
    <line x1="7" y1="15" x2="17" y2="15" stroke="currentColor" strokeWidth="1.4" />
    <line x1="7" y1="19" x2="17" y2="19" stroke="currentColor" strokeWidth="1.4" />
  </Svg>
);

export const HoopIcon = ({ className }) => (
  <Svg className={className}>
    <ellipse cx="12" cy="13" rx="8" ry="4" stroke="currentColor" strokeWidth="1.7" />
    <ellipse cx="12" cy="13" rx="4.6" ry="2.3" stroke="currentColor" strokeWidth="1.3" />
  </Svg>
);

export const MiniGoalIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M4 18V8h16v10" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M4 8l2-3h12l2 3" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M8 8v10M12 8v10M16 8v10M4 12h16M4 15h16" stroke="currentColor" strokeWidth="0.7" opacity="0.65" />
  </Svg>
);

export const GoalIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M3 20V6h18v14" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
    <path d="M3 20l3-2M21 20l-3-2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path d="M7 6v14M11 6v14M15 6v14M19 6v14M3 10h18M3 14h18" stroke="currentColor" strokeWidth="0.6" opacity="0.6" />
  </Svg>
);

export const DummyIcon = ({ className }) => (
  <Svg className={className}>
    <circle cx="12" cy="5.4" r="2" fill="currentColor" />
    <path d="M8.4 20l1-8a2.6 2.6 0 015.2 0l1 8" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <line x1="12" y1="9.6" x2="12" y2="20" stroke="currentColor" strokeWidth="1.3" strokeDasharray="1.5 1.3" />
  </Svg>
);

export const ZoneIcon = ({ className }) => (
  <Svg className={className}>
    <rect x="4.5" y="4.5" width="15" height="15" rx="2" fill="currentColor" opacity="0.28" stroke="currentColor" strokeWidth="1.5" />
  </Svg>
);

export const TextIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M6 18L10.5 6h1L16 18M7.6 14h5.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export const NumberIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M9 4L7.4 20M16.6 4L15 20M5 9h15M4 15h15" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </Svg>
);

export const ArrowIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export const CurvedArrowIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M5 17c2-7 9-10 13-7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M14.5 7.2l3.5 3-4 1.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export const LineIcon = ({ className }) => (
  <Svg className={className}><line x1="5" y1="17" x2="19" y2="7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></Svg>
);

export const DashedLineIcon = ({ className }) => (
  <Svg className={className}><line x1="5" y1="17" x2="19" y2="7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeDasharray="2.6 2.2" /></Svg>
);

export const FreehandIcon = ({ className }) => (
  <Svg className={className}><path d="M4 16c2-6 4 4 6-2s4 5 6-1 3 1 4-3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></Svg>
);

export const MovementPathIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M4 17c4-9 12-9 12-9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeDasharray="0.1 3" />
    <path d="M13 5.2l3 2.8-3.6 1.4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export const PassPathIcon = ({ className }) => (
  <Svg className={className}>
    <line x1="4" y1="16" x2="15" y2="8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeDasharray="2.4 2" />
    <circle cx="17.5" cy="6.3" r="2.3" stroke="currentColor" strokeWidth="1.4" />
  </Svg>
);

export const DribblePathIcon = ({ className }) => (
  <Svg className={className}>
    <path d="M3.5 16c2-1.6 2-3.4 4-5s2 3.4 4 1.8 2-3.4 4-1.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="17.5" cy="9.4" r="2" stroke="currentColor" strokeWidth="1.4" />
  </Svg>
);

export const CircleIcon = ({ className }) => (
  <Svg className={className}><circle cx="12" cy="12" r="7" stroke="currentColor" strokeWidth="1.6" /></Svg>
);

export const RectIcon = ({ className }) => (
  <Svg className={className}><rect x="4.5" y="6" width="15" height="12" rx="1.4" stroke="currentColor" strokeWidth="1.6" /></Svg>
);

export const ZoneAreaIcon = ({ className }) => (
  <Svg className={className}><rect x="4.5" y="6" width="15" height="12" rx="1.4" stroke="currentColor" strokeWidth="1.6" strokeDasharray="2.6 2" /></Svg>
);

export const SPORT_ICONS = {
  player_a: PlayerIcon, player_b: PlayerIcon, goalkeeper: KeeperIcon, neutral: NeutralIcon, coach: CoachIcon,
  ball: BallIcon, cone: ConeIcon, hurdle: HurdleIcon, pole: PoleIcon, ladder: LadderIcon, hoop: HoopIcon,
  mini_goal: MiniGoalIcon, goal: GoalIcon, dummy: DummyIcon, zone: ZoneIcon, text: TextIcon, number: NumberIcon,
  arrow: ArrowIcon, curved_arrow: CurvedArrowIcon, line: LineIcon, dashed_line: DashedLineIcon, freehand: FreehandIcon,
  movement_path: MovementPathIcon, pass_path: PassPathIcon, dribble_path: DribblePathIcon,
  circle: CircleIcon, rect: RectIcon, zone_area: ZoneAreaIcon,
};
